export class Usuario {

 public id:number;
 public email:string;
 public nombre:string;
 public apellidos:string;
 public clave:string;
 public tipo:string;
 public codigoConsorcio:string;
 public usuario:string;


}


// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/model/usuario.ts